exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.room-type-title[data-v-3e2ec72d]\n{\n    font-weight: bold;\n    font-size: x-large;\n}\n@media screen and (max-width: 768px) {\n.room-type-title[data-v-3e2ec72d], .room-type-description[data-v-3e2ec72d], .icons[data-v-3e2ec72d]{\n        text-align: center;\n}\n}\n@media (min-width: 768px) {\n.price-container[data-v-3e2ec72d]{\n        border-left: solid lightgrey 1px;\n        height: 200px !important;\n}\n}\n#book-now-btn[data-v-3e2ec72d]:hover{\n    border-radius: 25px !important;\n    background-color: #0a3544 !important;\n    transition:0.6s;\n}\n\n", ""]);

// exports
